<template>
  <span v-if="!isLinkClass()" :class="['read-only', definition.id]" v-text="getObjectTextValue()" />
  <span v-else-if="getObjectTextValue() && getObjectTextValue() !== '-'" :class="['read-only', 'link', definition.id]">
    <a :href="getObjectTextValue()" target="_blank">{{getObjectTextValue()}} <i class="fas fa-external-link-alt"></i></a>
  </span>
</template>

<script>
import transport from 'vue-definition-utils/src/utils/transport'

export default {
  name: 'definition-read-only',
  props: [
    'definitionId',
    'definition',
    'object',
    'languageSelected',
    'visualDefinition'
  ],
  data () {
    return {
    }
  },
  methods: {
    getObjectTextValue () {
      var languageSelectedKey = null
      if (this.languageSelected) {
        languageSelectedKey = this.languageSelected.key
      }
      return transport.methods.getObjectTextValue(this.visualDefinition.definition, this.definition, this.object, languageSelectedKey)
    },
    isLinkClass () {
      var definition = this.visualDefinition.getDefinitionFields(this.definition.id)
      return this.isClass(definition.class, 'link')
    },
    isClass (definitionClass, classStr) {
      var result = false
      if (definitionClass) {
        var classes = definitionClass.split(' ')
        if (classes && classes.length > 0) {
          for (var i = 0; i < classes.length && !result; i++) {
            result = (classes[i] === classStr)
          }
        }
      }
      return result
    }
  }
}
</script>

<style lang="scss" scoped>
.link {
  a {
    text-decoration: none;
    color: #56becb;

    i {
      font-size: 12px;
      margin-left: 5px;
    }

    &:hover {
      text-decoration: underline;
    }
  }
}
</style>



// WEBPACK FOOTER //
// node_modules/vue-definition/src/components/item/readOnly.vue